import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import FilterDistance from "./FilterDistance.js";
import FilterState from "./FilterState.js";
import FilterNationals from "./FilterNationals.js";
import icon_star_nationalorgs from "../../assets/images/icons/icon-star-nationalorgs.svg";

const useStyles = makeStyles({
  btn_primary: {
    color: "#D81D6D!important",
    borderRadius: "60px",
    border: "2px solid #D81D6D !important",
    background: "#fff",
    marginRight: "20px"
  },
  btn_secondary: {
    color: "#fff !important",
    borderRadius: "60px",
    border: "2px solid #D81D6D !important",
    background: "#D81D6D !important"
  }
});

const FilterResults = props => {
  const {
    markerMap,
    currentView,
    filtersUpdated,
    nationalFilterUpdated,
    currentLocation,
    filtersCount,
    isMobile,
    resetFilters
    //togglePinsOff
  } = props;
  const classes = useStyles();

  //current filters checked
  const [stateFilters, setStateFilters] = useState([]);
  const [distanceFilters, setDistanceFilters] = useState([]);
  const [nationalFilters, setNationalFilters] = useState([]);
  const [currentFiltersCount, setFiltersCount] = useState({ count: 0 });
  const [resetComponent, triggerResetComponent] = useState(false);

  //state to pass results
  const [allFilters, setAllFilters] = useState([]);
  const [expanded, setExpanded] = useState();

  const distanceFilter = distance => {
    setDistanceFilters(distance);
  };

  const stateFilter = states => {
    setStateFilters(states);
  };

  const nationalFilter = national => {
    setNationalFilters(national);
    nationalFilterUpdated(national);
  };

  var allFiltersArray;

  //updated filtered items array
  const updateFilters = () => {
    allFiltersArray = [];
    //gets states selected and pushed to state
    markerMap.map(marker => {
      //all data loop
      //gets state location of each data point
      let locationState = marker[1].State;

      //console.log(locationState);

      Object.entries(stateFilters).map(function(filter) {
        //state filters loop
        let stateFilter = filter[0];

        if (locationState === stateFilter) {
          //state filter state is true
          let stateFilterActive = filter[1];

          if (stateFilterActive) {
            allFiltersArray.push([marker[0], marker[1]]);
          }
        }
      });
    });

    //get number of state filters actve for count
    Object.entries(stateFilters).map(function(filter) {
      let stateFilter = filter[1];
      if (stateFilter) {
        setFiltersCount(prevState => {
          return { count: prevState.count + 1 };
        });
      }
    });

    //get distance filter
    var distanceFilter;
    Object.entries(distanceFilters).map(function(filter) {
      if (filter[1] === true) {
        distanceFilter = filter[0];

        //update filter count for button
        setFiltersCount(prevState => {
          return { count: prevState.count + 1 };
        });

        //covert object to meters
        switch (distanceFilter) {
          case "miles25":
            distanceFilter = 40234;
            break;
          case "miles50":
            distanceFilter = 80467;
            break;
          case "miles100":
            distanceFilter = 160934;
            break;
          case "miles150":
            distanceFilter = 241402;
            break;
          case "miles250":
            distanceFilter = 402336;
            break;
          case "miles500":
            distanceFilter = 804672;
            break;
        }
      }
    });

    //update national org filter to count
    if (nationalFilters) {
      setFiltersCount(prevState => {
        return { count: prevState.count + 1 };
      });
    }

    if (distanceFilter !== undefined) {
      calculateDistance(distanceFilter);
    } else {
      setAllFilters(allFiltersArray);
    }
  };

  const calculateDistance = distanceFilter => {
    const service = new window.google.maps.DistanceMatrixService();
    const locationsArrayGroup1 = [];
    const dataArrayGroup1 = [];
    const locationsArrayGroup2 = [];
    const dataArrayGroup2 = [];
    var distanceArray = [];

    ///Fix for now
    //breaking API calls into 2 parts because the distance matrix limits to 25
    //locations per call

    let markerMapCopy = [...markerMap];
    let half = Math.ceil(markerMap.length / 2);
    let locationsArray1 = markerMapCopy.splice(0, half);
    let locationsArray2 = markerMapCopy.splice(-half);

    //get lat/lng of all places
    locationsArray1.map(marker => {
      let lag_lng = marker[1].Latitude + "," + marker[1].Longitude;
      dataArrayGroup1.push([marker[0], marker[1]]);
      locationsArrayGroup1.push(lag_lng);
    });

    locationsArray2.map(marker => {
      let lag_lng = marker[1].Latitude + "," + marker[1].Longitude;
      dataArrayGroup2.push([marker[0], marker[1]]);
      locationsArrayGroup2.push(lag_lng);
    });

    let currentPosition = currentLocation.lat + "," + currentLocation.lng;
    //let currentPosition = "Miami FL";

    const matrixOptions1 = {
      origins: [currentPosition], // technician locations
      destinations: locationsArrayGroup1, // customer address limit 25 per query
      travelMode: "DRIVING",
      unitSystem: window.google.maps.UnitSystem.IMPERIAL
    };

    const matrixOptions2 = {
      origins: [currentPosition], // technician locations
      destinations: locationsArrayGroup2, // customer address limit 25 per query
      travelMode: "DRIVING",
      unitSystem: window.google.maps.UnitSystem.IMPERIAL
    };
    // Call Distance Matrix service
    service.getDistanceMatrix(matrixOptions1, callbackGroup1);

    // Callback function used to process Distance Matrix response
    function callbackGroup1(response, status) {
      if (status !== "OK") {
        //alert("Error with distance matrix callbackgroup 1");
        //alert(response, status);
        return;
      } else {
        distanceArray = [];
        response.rows[0].elements.map(location => {
          distanceArray.push(location.distance.value);
        });

        distanceArray.map((item, index) => {
          if (item <= distanceFilter) {
            let currentRef = dataArrayGroup1[index][0];
            let currentData = dataArrayGroup1[index][1];

            allFiltersArray.push([currentRef, currentData]);
          }

          //sets
          if (distanceArray.length === index + 1) {
            service.getDistanceMatrix(matrixOptions2, callbackGroup2);
          }
        });
      }
    }
    function callbackGroup2(response, status) {
      if (status !== "OK") {
        //alert("Error with distance matrix callbackgroup 2");
        //alert(response, status);
        return;
      } else {
        distanceArray = [];
        response.rows[0].elements.map(location => {
          distanceArray.push(location.distance.value);
        });

        distanceArray.map((item, index) => {
          if (item <= distanceFilter) {
            let currentRef = dataArrayGroup2[index][0];
            let currentData = dataArrayGroup2[index][1];

            allFiltersArray.push([currentRef, currentData]);
          }

          //sets
          if (distanceArray.length === index + 1) {
            //console.log("allFiltersArray2: " + allFiltersArray);
            setAllFilters(allFiltersArray);
          }
        });
      }
    }
  };

  const resetCount = () => {
    triggerResetComponent(true);
    setAllFilters([]);
    setFiltersCount({ count: 0 });
    filtersCount({ count: 0 });
  };

  const filterSearch = () => {
    //clear selected pins
    setAllFilters([]);
    setFiltersCount({ count: 0 });
    updateFilters();
  };

  useEffect(() => {
    filtersCount(currentFiltersCount);
    triggerResetComponent(false);
    filtersUpdated(allFilters);
    //console.log(allFilters);
  }, [allFilters]);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    resetCount();
  }, [resetFilters]);

  //added hook if user clears all filters manually and hits save
  useEffect(() => {
    if (currentFiltersCount.count == 0) {
      //console.log("manually trigger reset component");
      //togglePinsOff
      triggerResetComponent(true);
    }
  }, [currentFiltersCount]);

  return (
    <div
      className={
        currentView.expandView && !isMobile
          ? "filterResultsExpanded"
          : "filterResults"
      }
    >
      <div className="topFilters">
        <div>
          <Accordion
            expanded={
              currentView.expandView ? true : expanded === "nationalPanel"
            }
            onChange={handleChange("nationalPanel", false)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                NATIONAL ORGANIZATIONS
                <img
                  style={{
                    display: "inline-block",
                    position: "relative",
                    top: "2px",
                    left: "12px"
                  }}
                  alt="White star in pink circle"
                  src={icon_star_nationalorgs}
                ></img>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FilterNationals
                nationalFilter={nationalFilter}
                expandView={false}
                resetComponent={resetComponent}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={
              currentView.expandView ? true : expanded === "distancePanel"
            }
            onChange={handleChange("distancePanel", false)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>DISTANCE</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <FilterDistance
                distanceFilter={distanceFilter}
                expandView={false}
                resetComponent={resetComponent}
                currentLocation={currentLocation}
              />
            </AccordionDetails>
          </Accordion>
        </div>

        <Accordion
          expanded={currentView.expandView ? true : expanded === "statesPanel"}
          onChange={handleChange("statesPanel", false)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>STATE</Typography>
          </AccordionSummary>
          <AccordionDetails className="scroll-bar">
            <FilterState
              stateFilter={stateFilter}
              expandView={false}
              resetComponent={resetComponent}
            />
          </AccordionDetails>
        </Accordion>
      </div>

      <div className="bottomBtns">
        <div className="filterButtonRow">
          <Button
            className="btn_base btn_primary"
            style={{ marginRight: "20px" }}
            onClick={event => resetCount(event)}
          >
            RESET
          </Button>
          <Button
            className="btn_base btn_secondary"
            onClick={event => filterSearch(event)}
          >
            SAVE
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterResults;
